<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-autocomplete :label="labels.tarf" :items="tarfList" v-model="filters.tarf" item-text="value" item-value="code" data-vv-name="tarf" :data-vv-as="labels.tarf" :error-messages="errors.collect('tarf')" v-validate="'max:1'"></v-autocomplete>
                      </v-flex>
                      <v-flex md6>
                        <v-autocomplete :label="labels.busCls" :items="busClsList" v-model="filters.busCls" item-text="value" item-value="code" data-vv-name="busCls" :data-vv-as="labels.busCls" :error-messages="errors.collect('busCls')" v-validate="'max:4'"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-autocomplete :label="labels.benefit" :items="benefitList" v-model="filters.benefit" item-text="value" item-value="code" data-vv-name="benefit" :data-vv-as="labels.benefit" :error-messages="errors.collect('benefit')" v-validate="'max:4'"></v-autocomplete>
                      </v-flex>
                      <v-flex md6>
                        <cal-picker :label="labels.effDate" v-model="filters.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Tariff Benefits
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.tarf }}</td>
                <td>{{ row.item.busCls }}</td>
                <td>{{ row.item.benefit }} - {{ row.item.benDesc}}</td>
                <td>{{ formatDisplayDate(row.item.effDate) }}</td>
                <td>{{ formatDisplayDate(row.item.expDate) }}</td>
                <td>{{ row.item.benType }}</td>
                <td>{{ row.item.defBen ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.addBen ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.gapCalcMethod }}</td>
                <td>{{ row.item.napSubLevel }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Tariff Benefit?
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Tariff', value: 'tarf' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Benefit', value: 'benefit' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'Benefit Type', value: 'benType' },
        { text: 'Default Benefit', value: 'defBen' },
        { text: 'Additional Benefit', value: 'addBen' },
        { text: 'GAP Method', value: 'gapCalcMethod' },
        { text: 'NAP Level', value: 'napSubLevel' },
        TableConst.tableActionHeader
      ],
      labels: {
        tarf: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        effDate: 'Effective Date '
      },
      filters: {
        tarf: undefined,
        busCls: undefined,
        benefit: undefined,
        effDate: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      busClsList: [],
      tarfList: [],
      benefitList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getTarfBenList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  tarf: datamap.tarf,
                  busCls: datamap.busCls,
                  benefit: datamap.benefit,
                  benDesc: datamap.benDesc,
                  effDate: datamap.effDate,
                  expDate: datamap.expDate,
                  benType: datamap.benType,
                  defBen: datamap.defBen,
                  addBen: datamap.addBen,
                  gapCalcMethod: datamap.gapCalcMethod,
                  napSubLevel: datamap.napSubLevel
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.tarf = undefined
      this.filters.busCls = undefined
      this.filters.benefit = undefined
      this.filters.effDate = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'tarfBenReview', params: { tarfBenMode: 'review', tarfBenObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'tarfBenReview', params: { tarfBenMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'tarfBenReview', params: { tarfBenMode: 'query', tarfBenObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteTarfBen
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doFetchBusClsList() {
      const apiURI = this.menu.getBusClsAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.busClsList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.busCls,
                  value: dataMap.busCls + ' - ' + dataMap.busClsDesc,
                  desc: dataMap.busClsDesc
                }
                this.busClsList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchTariffList() {
      const apiURI = this.menu.getTarfAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.tarfList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.tarf,
                  value: dataMap.tarf + ' - ' + dataMap.tarfDesc,
                  desc: dataMap.tarfDesc
                }
                this.tarfList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchBenefitList() {
      const apiURI = this.menu.getBenefitAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.benefitList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.benefit,
                  value: dataMap.benefit + ' - ' + dataMap.benDesc,
                  desc: dataMap.benDesc
                }
                this.benefitList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.tariffBenefitsParam.menu
    }
  },
  mounted() {
    this.doInit(true)
    this.doFetchBusClsList()
    this.doFetchTariffList()
    this.doFetchBenefitList()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
